import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=08d293a4"
import script from "./DropArea.vue?vue&type=script&lang=js"
export * from "./DropArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports